import { MLSListing } from '@aloft/toolkit-shared';

import { MLSDataColumn } from './MLSDataColumn.tsx';
import { MLSDataInfoSection } from './MLSDataInfoSection.tsx';
import { MLSDataValueWithLabel } from './MLSDataValueWithLabel.tsx';

export const MLSFeatures = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="Features" spanColumns>
    <MLSDataColumn>
      <MLSDataValueWithLabel value={listingData.DoorFeatures} label="Doors" />
      <MLSDataValueWithLabel leftAlign value={listingData.Flooring} label="Flooring" />
      <MLSDataValueWithLabel leftAlign value={listingData.Heating?.join(', ')} label="Heating" />
      <MLSDataValueWithLabel leftAlign value={listingData.Cooling} label="Cooling" />
      <MLSDataValueWithLabel
        leftAlign
        value={listingData.ExteriorFeatures?.join(', ')}
        label="Exterior"
      />
      <MLSDataValueWithLabel
        leftAlign
        value={listingData.InteriorFeatures?.join(', ')}
        label="Interior"
      />
      <MLSDataValueWithLabel
        leftAlign
        value={listingData.Appliances?.join(', ')}
        label="Appliances"
      />
      <MLSDataValueWithLabel
        leftAlign
        value={listingData.PatioAndPorchFeatures}
        label="Patio and Porch"
      />
      <MLSDataValueWithLabel leftAlign value={listingData.PoolFeatures} label="Pool" />
    </MLSDataColumn>
  </MLSDataInfoSection>
);
